import { useState, useEffect, useCallback } from 'react'
import { Download } from 'lucide-react'
import { isDesktop } from '@/lib/platform'

export function UpdateIndicator() {
  const [ready, setReady] = useState(false)
  const [version, setVersion] = useState<string>()
  const [confirming, setConfirming] = useState(false)
  const [pulse, setPulse] = useState(true)

  useEffect(() => {
    if (!isDesktop()) return

    window.ledgerDesktop.getUpdateStatus().then((s) => {
      if (s.ready) {
        setReady(true)
        setVersion(s.version)
      }
    })

    const unsub = window.ledgerDesktop.onUpdateReady((v) => {
      setReady(true)
      setVersion(v)
      setPulse(true)
    })

    return unsub
  }, [])

  // Stop pulse animation after 3 cycles (~4.5s)
  useEffect(() => {
    if (!pulse) return
    const timer = setTimeout(() => setPulse(false), 4500)
    return () => clearTimeout(timer)
  }, [pulse])

  const handleClick = useCallback(() => {
    if (confirming) {
      window.ledgerDesktop.restartToUpdate()
    } else {
      setConfirming(true)
      setTimeout(() => setConfirming(false), 4000)
    }
  }, [confirming])

  if (!ready) return null

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`relative flex items-center gap-1.5 rounded px-2 py-1 text-xs font-medium transition-colors ${
        confirming
          ? 'bg-indigo-600 text-white hover:bg-indigo-500'
          : 'text-emerald-400 hover:bg-white/10'
      }`}
      title={confirming ? 'Click again to restart' : `Update ready - restart to apply${version ? ` v${version}` : ''}`}
    >
      <Download
        size={14}
        className={pulse ? 'animate-pulse' : ''}
      />
      {confirming ? (
        <span>Restart now?</span>
      ) : null}
    </button>
  )
}
